module.exports = __webpack_public_path__ + "static/media/scan_to_pay_logos@3x.3454a35c.png";